import {ordoroFetch} from './ordoroFetch.js'
import {stringify} from './querystring.js'

export function formatV3APIURL(url, query) {
  url = url.replace(/\/$/, '')

  return `${window.ORDORO_BOOTSTRAP.env.PAPPY_ENV_API_URL}/v3${url}${query ? `?${stringify(query)}` : ''}`
}

export function apiversonFetch(method, url, data, options) {
  return ordoroFetch(
    method,
    formatV3APIURL(url, method === 'get' && data),
    data,
    options,
  )
}

export default {
  head(url, data, options) {
    return apiversonFetch('head', url, data, options)
  },
  get(url, data, options) {
    return apiversonFetch('get', url, data, options)
  },
  put(url, data, options) {
    return apiversonFetch('put', url, data, options)
  },
  post(url, data, options) {
    return apiversonFetch('post', url, data, options)
  },
  patch(url, data, options) {
    return apiversonFetch('patch', url, data, options)
  },
  delete(url, data, options) {
    return apiversonFetch('delete', url, data, options)
  },
}
